import * as React from "react";
import { Button, ButtonGroup, CircularProgress } from "@mui/material";

export default function NavigationHeader(props) {
  let user = props.user;
  let language = props.language;
  let admin = props.admin;
  let advisoryData = props.advisoryData;
  let currentStudentEmail = props.currentStudentEmail;
  let handleDrawerToggle = props.handleDrawerToggle;
  let signInWithGoogle = props.signInWithGoogle;
  let signOut = props.signOut;
  let resetCurrentStudentEmail  = props.resetCurrentStudentEmail ;

  return (
    <header className="App-header" id="body">
      {!user ? (
          <Button
            variant="contained"
            onClick={signInWithGoogle}
            color="warning"
          >
            {language === "english"
              ? "Student/Staff Sign-in"
              : "inicia sesión con Google"}
          </Button>
      ) : (
        <ButtonGroup>
          <Button
            variant="contained"
            color="error"
            //style={{ margin: "40px" }}
            onClick={signOut}
          >
            {language === "english" ? `Signout` : `Desconectar`}
          </Button>
          <Button
            color="info"
            variant="contained"
            href="https://docs.google.com/forms/u/1/d/e/1FAIpQLSd32s_1r4_wj4TtNznlIqV_OgbaZaZ2qq8eQVL8sBs9te2Pvg/viewform"
            target="_blank"
            onClick={
              () => console.log(" add analytics")
              //firebase.analytics().logEvent("page_view", {
              //  page_title: "opened feedback form",
              //})
            }
          >
            {language === "english" ? "feedback / support" : "reacción / apoyo"}
          </Button>
        </ButtonGroup>
      )}
    </header>
  );
}
